import React, {useState} from 'react';
import Modal from 'react-modal';
import styles from './AdminTaxInvoiceIssuePopUp.module.css';
import Button from "../../../components/common/button/Button";

interface CancelPaymentPopUpProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (reason: string, amount?: number) => void;
}

//세금계산서 발행 팝업
const AdminTaxInvoiceIssuePopUp: React.FC<CancelPaymentPopUpProps> = ({
                                                                   isOpen,
                                                                   onClose,
                                                                   onConfirm
                                                               }) => {
    const [memo, setMemo] = useState('');

    //세금계산서 발행 로직
    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        //발행 메모 필수 기입
        if (!memo.trim()) return;
        onConfirm(memo);
        setMemo('');
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            className={styles.modal}
            overlayClassName={styles.overlay}
        >
            <div className={styles.container}>
                <h2 className={styles.title}>세금계산서 발행</h2>
                <form onSubmit={handleSubmit}>

                    {/*메모 입력*/}
                    <textarea
                        className={styles.textarea}
                        value={memo}
                        onChange={(e) => setMemo(e.target.value)}
                        placeholder="발행 메모를 입력하세요"
                        required
                    />
                    <div className={styles.buttons}>
                        {/*취소 버튼*/}
                        <Button
                            type="submit"
                            variant="primary"
                            size="small"
                            disabled={!memo.trim()}
                        >
                            발행
                        </Button>
                        {/*팝업 닫기 버튼*/}
                        <Button
                            type="button"
                            variant="secondary"
                            size="small"
                            onClick={onClose}
                        >
                            닫기
                        </Button>
                    </div>
                </form>
            </div>
        </Modal>
    );
};

export default AdminTaxInvoiceIssuePopUp;